import React, { useEffect, useState, memo, useCallback } from "react";
import ProductService from "../../services/ProductService";
import { useSideMenu } from "../../sideMenu/sideMenu.context";
import { useMainContext } from "../../store/Context";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import "./Options.style.scss";
import { Utils } from "../../Utils/Utils";

const Options = ({ intl }) => {
  const [activeStrap, setActiveStrap] = useState(null);
  const [ total, setTotal ] = useState(null);
  const { straps, getProductsIds, getTotal, product } = useMainContext();
  const { setOpen } = useSideMenu();

  const activeIdStrap = ProductService.getStrapId();

  useEffect(() => {
    if (product && product.strap) {
      setActiveStrap(product.strap);
    } else {
      setActiveStrap(straps.filter((x) => x.id === activeIdStrap)[0]);
    }

    const total = getTotal();
    setTotal(total);
  }, [activeIdStrap, product, getTotal, setActiveStrap, setTotal]);

  useEffect(() => {
    // On refresh, window is not ready and currency symbol is not displayed
    // check after 2sec if the window is ready and change the total with currency display
    let timeOut = setTimeout(() => {
      const formatTotal = getTotal();
      if (total !== formatTotal) {
        setTotal(formatTotal);
      }
    }, [2000]);

    return () => clearTimeout(timeOut);
  }, [total, getTotal, setTotal]);

  const ButtonText = useCallback(() => {
    const text = intl.formatMessage({ id: "Product.button" });
    return (
      <p
        style={{
          ...(Utils.hasJapaneseOrChinese(text) && {
            width: "100%",
          }),
        }}
      >
        {text}
      </p>
    );
  }, []);

  const handlerOnAddToCart = () => {
    window &&
      window.dataLayer &&
      window.dataLayer.push({ event: "orderClick" });
  };

  return (
    <div className="StrapOptions">
      <div
        className="StrapOptions-Item StrapOptions-Colores"
        onClick={() => setOpen("straps")}
      >
        <p>
          <FormattedMessage id="Compositions.title.colours" /> ({straps.length})
        </p>
        {activeStrap && (
          <div className="StrapOptions-Colores-Image">
            <img
              src={activeStrap.images[0].image0}
              alt="active strap options"
            />
          </div>
        )}
        <div className="StrapOptions-Arrow" />
      </div>
      <div
        onClick={() => setOpen("selection")}
        className="StrapOptions-Item StrapOptions-Views"
      >
        <p>
          <FormattedMessage id="Product.viewAction" />
        </p>
        <div className="StrapOptions-Arrow" />
      </div>
      <button
        data-add-product-ids={getProductsIds()}
        className="StrapOptions-Item StrapOptions-Price"
        onClick={handlerOnAddToCart}
      >
        <div>
          <p>{total}</p>
        </div>
        <div>
          <ButtonText />
        </div>
        <label>+</label>
      </button>
    </div>
  );
};
export default injectIntl(memo(Options));
